<script lang="ts">
    import {  Col } from "sveltestrap";
    import Card from "../../UiCommenCard.svelte";
    import {BasicModal} from "../../../../utils/Constant/Constant"
    import Simpledemo from "./Simpledemo.svelte";
    import Scrollinglongcontent from "./Scrollinglongcontent.svelte";
    import Verticallycenteredmodal from "./Verticallycenteredmodal.svelte";
    import Tooltipspopoversmodal from "./Tooltipspopoversmodal.svelte";
    import Usinggridmodal from "./Usinggridmodal.svelte"

</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={BasicModal} CardBodyprops="btn-showcase">
      <div slot="contentbody">
        <Simpledemo />
        <Scrollinglongcontent />
        <Verticallycenteredmodal />
        <Tooltipspopoversmodal />
        <Usinggridmodal />
      </div>
    </Card>
</Col>